'use client'

import classNames from 'classnames'
import React, { useEffect, useState } from 'react'

import { ReactComponent as ShareIcon } from '~/assets/icons/share.svg'
import useOutsideClick from '~/hooks/use-click-outside'

import ShareLinks from '../links'

interface Props {
  title: string
  shareUrl: string
}

const ShareButton: React.FC<Props> = ({ shareUrl, title }) => {
  const [isModalVisible, setModalVisible] = useState(false)
  const reference = useOutsideClick(() => setModalVisible(false))

  const onClickModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setModalVisible(true)
  }

  useEffect(() => {
    const links = reference.current.querySelectorAll('a')
    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopPropagation()
        setModalVisible(false)
      })
    })
  }, [reference])

  return (
    <div ref={reference as any} className="relative z-40 flex-none">
      <button
        className="w-6 h-6 flex items-center justify-end hover:text-hover-color"
        onClick={onClickModal}
        aria-label="Compartilhar"
      >
        <ShareIcon className="w-4 h-4" />
      </button>
      <div
        className={classNames(
          'absolute z-40 -top-2 -right-2 origin-top-right bg-neutral-white rounded-3xl shadow-lg p-6 transition-[opacity,transform] duration-300 ease-out w-max max-w-[80vw] ',
          {
            'opacity-100 scale-100 pointer-events-auto cursor-default':
              isModalVisible,
            'opacity-0 scale-50 pointer-events-none': !isModalVisible,
          }
        )}
      >
        <p className="text-sm font-bold text-gray-700">Compartilhar</p>
        <div className="mt-2 flex items-center flex-wrap gap-2 text-neutral-1000">
          <ShareLinks shareUrl={shareUrl} title={title} />
        </div>
      </div>
    </div>
  )
}

export default ShareButton
